// Auto-generated normalizer for table: Cat_UnidadesOrg
export function catUnidadesOrgNormalize(row) {
  return {
    idZonaGeografica: row.idZonaGeografica ?? row.IdZonaGeografica ?? row["idZonaGeografica"]  ?? 0,
    idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? row['IdUnidadOrganizacional'] ?? 0,
    idDireccion: row.idDireccion ?? row.IdDireccion ?? row['IdDireccion'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    idTipoUndiadOrganizacional: row.IdTipoUndiadOrganizacional ?? row.idTipoUndiadOrganizacional ?? row['idTipoUnidadOrganizacional'] ?? 0,
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? 0,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row['NombreEmpresa'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
